export const validateValueNotPresentInList = (value: string, list: string[], message: string): boolean | string => {
  if (list.includes(value)) {
    return message;
  }
  return true;
};
